import { IPortabilityCMS } from '@vfit/consumer/data-access';
import { purify } from '@vfit/shared/themes';

const organizePortabilityNumberCard = (portabilityNumberCardCMS: IPortabilityCMS) => ({
  title: portabilityNumberCardCMS?.portability?.telephone?.title || '',
  description: portabilityNumberCardCMS?.portability?.telephone?.description || '',
  label: portabilityNumberCardCMS?.portability?.selectInput?.telephone || '',
});

const organizePortabilityError = (portabilityNumberCardCMS: IPortabilityCMS) => ({
  titleError: portabilityNumberCardCMS?.portability?.errorModal?.title || '',
  messageError: portabilityNumberCardCMS?.portability?.errorModal?.message || '',
});

const getValidationByID = (editorialConfigs, id: string) => {
  const parser = new DOMParser();
  const value = editorialConfigs?.find((e) => e.id === id)?.value || '';
  const doc = parser.parseFromString(purify([value || ''])?.[0] || '', 'text/html');
  return doc?.body?.textContent?.replace('\n', '') || '';
};

const organizeValidations = (editorialConfigs): { requiredField: string; validNumber: string } => {
  return {
    requiredField: getValidationByID(editorialConfigs, 'requiredField'),
    validNumber: getValidationByID(editorialConfigs, 'validNumber'),
  };
};

export { organizePortabilityError, organizePortabilityNumberCard, organizeValidations };
